import $ from 'jquery';

function TitleCaption(element) {
  this.element = element;
  this.$element = $(element);
  this.toggleClass = this.toggleClass.bind(this);
  this.listen = this.listen.bind(this);
  this.init();
  this.listen();
}

TitleCaption.prototype = {
  init() {
    const title = this.$element.find('.node-header .title').text();
    $(`<div class="tile-caption"><span>${title}</span></div>`).insertBefore(this.$element.find('.node-inner'));
  },
  toggleClass() {
    this.$element.find('.node-teaser').toggleClass('expanded');
  },
  listen() {
    this.$element.find('.tile-caption').on('click', this.toggleClass);
  },
};

export default TitleCaption;
